import { useTranslate } from "@refinedev/core";
import { useTemplateData } from "../../../hooks/useTemplateData";
import { PanelSection } from "../PanelSection";
import { TransitionConfigFeature } from "./features/TransitionConfigFeature";
import { AnimationsTab } from "../AnimationsTab";

export const MotionTab = () => {
  const t = useTranslate();

  const {
    templatesData: { hasTransition },
  } = useTemplateData();

  return (
    <>
      <PanelSection
        title={t("components.templates.settings.motionTab.transition.title")}
        subtitle={t(
          "components.templates.settings.motionTab.transition.description"
        )}
      >
        <TransitionConfigFeature hasTransition={hasTransition} />
      </PanelSection>
      <AnimationsTab />
    </>
  );
};
